import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { useContext } from 'react';
import Breakpoint from '../Breakpoint';
import { AVERAGE_DESKTOP_WIDTH } from '../Breakpoint/Breakpoint';
import hoist from '../hoist/hoist';
var BreakpointContext = /*#__PURE__*/React.createContext({
  bpName: 'lg',
  bpOptions: ['sm', 'md', 'lg'],
  width: AVERAGE_DESKTOP_WIDTH
});

var Provider = function Provider(_ref) {
  var children = _ref.children,
      outerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Breakpoint, outerProps, function (innerProps) {
    return /*#__PURE__*/React.createElement(BreakpointContext.Provider, {
      value: innerProps
    }, children);
  });
};

export var withBreakpoint = function withBreakpoint(Component) {
  return function (props) {
    var hoc = /*#__PURE__*/React.createElement(BreakpointContext.Consumer, null, function (breakpoint) {
      return /*#__PURE__*/React.createElement(Component, _extends({
        breakpoint: breakpoint
      }, props));
    });
    hoist(hoc, Component);
    return hoc;
  };
};
export var useBreakpoint = function useBreakpoint() {
  return useContext(BreakpointContext);
};
var Consumer = BreakpointContext.Consumer;
export default {
  Provider: Provider,
  Consumer: Consumer,
  Context: BreakpointContext
};